import { render, staticRenderFns } from "./examPage.vue?vue&type=template&id=f99c4482&scoped=true"
import script from "./examPage.vue?vue&type=script&lang=js"
export * from "./examPage.vue?vue&type=script&lang=js"
import style0 from "./examPage.vue?vue&type=style&index=0&id=f99c4482&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99c4482",
  null
  
)

export default component.exports